import { SceneTransforms, Cartesian3, EllipsoidalOccluder, Ellipsoid, ConstantPositionProperty } from "cesium"
import CustomCesium from "../../utils/custom-cesium"
export default class CustomPopup {

    /**
     * 
     * @param {String | HTMLElement} content 
     * @param {Object} options 
     * @param {Boolean} [options.showClose] 是否显示关闭按钮
     * @param {String | HTMLElement} [options.title] 标题
     * @param {Function} [options.closeCallback] 关闭弹窗回调
     */
    constructor(content, options) {
        this._options = Object.assign({
            id: 'popup',
            showClose: false,
            title: null,
            fontScale: 1.0,
            outSideLineHeight: 1.5,
            className: '',
            closeCallback: undefined
        }, options)
        this.infowindowId = `popupHtml_${this._options.id}`
        this._createPopupHTMLElement(content)
    }

    /**
     * @private
     */
    _createPopupHTMLElement(content) {
        const existEl = document.getElementById(this.infowindowId)
        if(existEl) {
            existEl.parentNode.removeChild(existEl)
        }

        this.infoDivEl = document.createElement('div')
        this.infoDivEl.id = this.infowindowId
        if(this._options.className) {
            this.infoDivEl.className = `cesium-popup ${this._options.className}`
        }else {
            this.infoDivEl.className = 'cesium-popup'
        }
        const contentFrame = document.createElement('div')
        contentFrame.id = 'contentFrame'
        contentFrame.className = 'content-frame'

        if(this._options.title) {
            const titleElment = document.createElement('div')
            titleElment.id = 'popupTitle'
            titleElment.className = 'popup-title'
            if(typeof this._options.title === 'string') {
                titleElment.innerHTML = this._options.title
            }else{
                titleElment.appendChild(this._options.title)
            }

            contentFrame.appendChild(titleElment)

            this.titleHtmlElement = titleElment
        }

        if(this._options.showClose) {
           const closeBtn = document.createElement('a')
           closeBtn.className = 'close-btn'
           closeBtn.innerText = '+'
           closeBtn.onclick = this.hide.bind(this)
           contentFrame.appendChild(closeBtn)
        }

        if(content) {
            const contentHtml = document.createElement('div')
            contentHtml.className = 'content'
            if(typeof content === 'string') {
                contentHtml.innerHTML = content
            }else {
                contentHtml.appendChild(content)
            }
            contentFrame.appendChild(contentHtml)
            this.contentHtmlElement = contentHtml
        }

        this.infoDivEl.appendChild(contentFrame)

        const outsideHtml = document.createElement('div')
        outsideHtml.className = 'out-side'

        const topLineHtml = document.createElement('div')
        topLineHtml.className = 'top-line'
        outsideHtml.appendChild(topLineHtml)

        const tiltLineHtml = document.createElement('div')
        tiltLineHtml.className = 'tilt-line'
        outsideHtml.appendChild(tiltLineHtml)

        const circleHtml = document.createElement('i')
        circleHtml.className = 'circle'
        outsideHtml.appendChild(circleHtml)

        this.infoDivEl.appendChild(outsideHtml)
    }

    /**
     * 
     * @param {CustomCesium} viewer 
     */
    addTo(viewer) {
        this.viewer = viewer.getViewer()
        this.addListener()
        let mapViewer = document.querySelector(".cesium-viewer")
        mapViewer.append(this.infoDivEl)
        return this
    }

    setPosition(position) {
        this.position = position
        this.currentPosition = SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, position._value)
        this._refreshPoint(this.currentPosition)
        return this
    }

    setLngLat(point) {
        this.position = new ConstantPositionProperty(Cartesian3.fromDegrees(point[0], point[1], 0))
        this.currentPosition = SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, this.position._value)
        this._refreshPoint(this.currentPosition)
        return this
    }

    setContent(content) {
        if(typeof content === 'string') {
            this.contentHtmlElement.innerHTML = content
        }else {
            this.contentHtmlElement.innerHTML = ''
            this.contentHtmlElement.appendChild(content)
        }
        return this
    }

    setTitle(title) {
        if(typeof title === 'string') {
            this.titleHtmlElement.innerHTML = title
        }else {
            this.titleHtmlElement.innerHTML = ''
            this.titleHtmlElement.appendChild(title)
        }

        return this
    }

    addListener() {
        this.viewer.scene.postRender.addEventListener(this._listenerEventFunction.bind(this))
    }

    _listenerEventFunction() {
        if(!this.position) {
            return
        }
        const status = this.viewer.scene.mode === 2 ? true : new EllipsoidalOccluder(Ellipsoid.WGS84, this.viewer.camera.position).isPointVisible(this.position._value)
        if(!status) {
            this._setOutSideOfScreen()
            return
        }
        const changedC = SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, this.position._value)
        if (this.currentPosition && changedC && this.currentPosition.x && changedC.x && this.currentPosition.y && changedC.y) {
            if ((this.currentPosition.x !== changedC.x) || (this.currentPosition.y !== changedC.y)) {
                this._refreshPoint(changedC)
                this.currentPosition = changedC
            }
        }
    }

    /**
     * @private
     */
    _refreshPoint(point) {
        let x = point.x
        let y = point.y
        this.infoDivEl.style.left = x + 'px'
        this.infoDivEl.style.top = y + 'px'
    }

    _setOutSideOfScreen() {
        this.infoDivEl.style.left = '-300px'
        this.infoDivEl.style.top = '-500px'
    }

    remove() {
        this.infoDivEl.parentNode.removeChild(this.infoDivEl)
        return null
    }

    show() {
        this.infoDivEl.style.display = 'block'
    }

    hide() {
        this.infoDivEl.style.display = 'none'
    }
}
